import { DealerBrand } from './Brand';
import { DealerGroup } from './DealerGroup';
import { DealerOem } from './Oem';
import { TradeInMarket } from './TradeInMarket';
import { DmaMapping, OemProgram } from './DspEntity';

export class Dealer {
    id?: number;
    dealerName: string = '';
    agencyId: number | undefined | null;

    agency?: {
        id: any;
        name: string;
        tfCustomerId: string;
        tfUserIsActive: boolean;
        creativeStudioIsActive: boolean;
        creativeStudioUserId: string | null;
    };
    verticalId: number | undefined;
    sasAccountId: number | undefined;
    dspEntityId: number | undefined;
    dv360EntityId: number | undefined;
    publicId: string = '';
    address: string = '';
    phone: string = '';
    city: string = '';
    state: string = '';
    zip: string = '';
    countryCode: string = 'US';
    url: string = '';
    logoUrl: string = '';
    polkDealerName?: string;
    agencyAdvertiserId: string = '';
    agencyMarketRegion: string = '';
    defaultBadge: string = '';
    fixedOpsBadge: string = '';
    preferredPhotoIndex: number = 1;
    minPhotoExportCount: number = 1;
    partsId: string = '';
    tradeInEnrolled = false;
    tradeInMarket?: TradeInMarket;
    amcInstanceId?: number;
    dspAdvertiser = '';
    dv360Advertiser = '';
    sizmekAdvertiserId = '';
    modified?: boolean;
    ageExportFilterOperator: string = '';
    ageExportFilterValue: number = 0;
    newUsedFilter: string = '';
    certifiedFilter: string = '';
    customLabelFilter: string = '';
    legalDisclaimer: string = '';
    dspReportImpressions: boolean = true;
    dspReportSummaryGeo: boolean = true;
    dspReportSummaryAppBySpend: boolean = true;
    dspTechnologyReportType: boolean = false;
    dspAdTagId: string = '';
    dspAdTagProvider: string = '';
    dspAdTagCode: string = '';
    ftAdvertiserId: string = '';
    activeStatus: boolean = true;
    ctaText: string = '';
    ctaButtonColor: string = '';
    ctaTextSecondary: string = '';
    ctaButtonColorSecondary: string = '';
    defaultAdImageUrl: string = '';
    defaultAdImageUrl300x600: string = '';
    defaultAdImageUrl160x600: string = '';
    defaultAdImageUrl728x90: string = '';
    showTrim: boolean = false;
    gatewayAmazonDSPIsActive: number = 0;
    imageFilter: string = '';
    tfTokenIsActive: boolean = false;
    tfApiToken: string = '';
    creativeStudioIsActive: boolean = false;
    creativeStudioUserId: string | null = null;

    websiteProvider: string = '';
    dmaMappings: Partial<DmaMapping>[] = [];
    // oems: Partial<Oem>[] = [];
    oems: Partial<DealerOem>[] = [];
    oemPrograms: Partial<OemProgram>[] = [];
    // brands: Partial<Brand>[] = [];
    brands: Partial<DealerBrand>[] = [];
    oemCode: string | null = null;
    dealerGroupId: number | null = null;
    dealerGroup: DealerGroup | null = null;
    certifiedStreamingProgram: boolean = false;
}
